<div class="store-status-view-container container">{{definition?.displayName}}</div>
